// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"3a3a1e56bc0fe804c16b","532":"451fa7b25cb58604412f","691":"dd383f4e3b617e62b012"}[chunkId] + ".js";
};